/**
 * @generated SignedSource<<afcabdc437192cfb019488372ce95bcd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventCardNew_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendButtonNew_query">;
  readonly " $fragmentType": "EventCardNew_query";
};
export type EventCardNew_query$key = {
  readonly " $data"?: EventCardNew_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCardNew_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventCardNew_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventAttendButtonNew_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "671bf54101b385818b5d6ce7f26cad35";

export default node;
